export default __webpack_public_path__ + "static/wave_message_mob-289ab8643bd16c739405c6357a390048.png";